var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title || _vm.$slots['header-actions'])?_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"row"},[(!!_vm.title)?_c('div',{class:{
					'col-xs-12': true, 
					'col-md-5': _vm.$slots['header-actions'],
				}},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.$slots['header-actions'])?_c('div',{class:{
					'col-xs-12': true, 
					'col-md-7': _vm.title,
					'text-right': true,
				}},[_c('div',{staticClass:"page-actions reverse"},[_vm._t("header-actions")],2)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-body"},[_vm._t("default")],2),_vm._v(" "),(!!_vm.$slots.footer)?_c('div',{staticClass:"box-footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }